exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".VY6g {\n    margin-top: 15px;\n    color: #707172;\n    font-weight: 600;\n    text-align: center;\n}\n\n._3itJ {\n    margin-top: 15px;\n    color: #707172;\n    text-align: center;\n    margin-bottom: 20px;\n}\n", ""]);

// exports
exports.locals = {
	"title": "VY6g",
	"text": "_3itJ"
};